<template>
  <sweet-modal ref="tab-config" :title="$t('ct-config-tabs')" width="50vw">

    <div class="d-flex">

      <div class="flex-1">
        <p>{{ $t('ct-config-tab-visibled')}}</p>
        <div class="form" v-if="areas_list">
          <div class="form-check" v-for="(type, index) in areas_list" :key="index">
            <input class="form-check-input" type="checkbox" name="option-list" :id="`option-${type}`" :value="type"
                   v-model="visible_areas_list">
            <label class="form-check-label" :for="`option-${type}`">{{ $t(`ct-${type}`) }}</label>
          </div>
        </div>
      </div>

      <div class="flex-1">
        <p>{{ $t('ct-config-tab-order')}}</p>
        <draggable v-model="draggable_areas_list" class="nav flex-column nav-pills form-draggable-list">
          <p class="mb-0" v-for="(tab, index) in draggable_areas_list" :key="index">
            <span class="nav-link active d-block mb-1">{{ $t(`ct-tab-${tab.name}`) }} </span>
          </p>
        </draggable>
      </div>
    </div>

    <button
      slot="button"
      class="btn btn-success"
      @click.prevent="save"
    >{{ $t('ct-save') }}
    </button>
  </sweet-modal>
</template>

<script>
import {SweetModal} from 'sweet-modal-vue';
import draggable from 'vuedraggable';

export default {
  name: 'Config',
  props: ['website_id'],
  components: {
    SweetModal,
    draggable
  },
  data() {
    return {
      element: false,
      callback: false,
      areas_list: ['profile', 'areas'],
      visible_areas_list: [],
      draggable_areas_list: []
    };
  },
  watch: {
    'visible_areas_list': function() {
      this.draggable_areas_list = [];
      this.visible_areas_list.forEach((e, i) => {
        this.draggable_areas_list.push({ id: i, name: e});
      });
    }
  },
  methods: {
    init(config, callback = false) {
      this.element = config;
      this.callback = callback;

      this.visible_areas_list = this.element.internal_config.visibleTabs;
    },

    openModal() {
      this.$refs['tab-config'].open();
    },

    save() {
      if (this.draggable_areas_list.length >= 1) {
        let value = this.element.internal_config;
        value.visibleTabs = [];
        this.draggable_areas_list.forEach((e, i) => {
          value.visibleTabs.push(e.name);
        });
        this.element.internal_config = Object.assign({}, this.element.internal_config, value);
        this.$refs['tab-config'].close();
      } else {
        this.$snotify.error(this.$t('ct-config-tab-isempty'));
      }
    }
  }
};
</script>

<style scoped>
  p{
    font-size: 16px;
  }
  .nav-link {
    font-size: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Members/ContentNavUser/Config.vue